import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'reduceCopValue' })
export class ReduceCopValuePipe implements PipeTransform {

  // Se inyecta el LOCALE_ID al constructor siempre que se utilicen pipes de angular
  constructor(@Inject(LOCALE_ID) private locale) { }

  /* transform(): Pipe para formatear un numero a Millones y miles
    value: Número a reducir
    type: Bandera para saber desde que número en adelante se reducirá
    └ (0) -> desde 1000000000, (1) -> desde 1000
  */
  transform(value: number, type = 1, decimals = 0): string {
    // options: array que guarda en [0] el valor con el que se reducirán los pesos, en [1] guarda el simbolo que se agregará
    let options = [];
    // ↓ Verifica entre rango mayor/menor a billones
    if (value >= 1000000000000 || value <= -1000000000000) {
      options = [1000000000000, "B"];
    } else if (value >= 1000000000 || value <= -1000000000) {
      // ↑ Verifica entre rango mayor/menor a miles de millones
      options = [Number(type) === 3 ? 1000000000 : 1000000, Number(type) === 3 ? "MM" : "M"];
    } else if ((value >= 1000000 || value <= -1000000) && (Number(type) === 1 || Number(type) === 3)) {
      // ↑ Verifica entre rango mayor/menor a millones
      options = [1000000, "M"];
    } else if ((value >= 1000 || value <= -1000) && Number(type) === 1) {
      // ↑ Verifica entre rango mayor/menor a miles
      options = [1000, "m"];
    } else { options = [1, ""]; }
    // ↑ Valor por defecto cuando no cumple ninguna condición

    // Devuelve en formato de peso colombiano el valor reducido agregando el símbolo correspondiente al final
    return new CurrencyPipe(this.locale).transform(value / options[0], 'COP', 'symbol', `1.0-${decimals}`) + " " + options[1];
  }

}
